import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'dday'
})
export class DdayPipe implements PipeTransform {

  transform(ms: number, args?: string): any {
    if (!ms) {
      return ms;
    }
    return calculateDaysLeft(ms);
  }


}


export function calculateDaysLeft (timestamp:number) {
  if (typeof timestamp !== 'number') return 0;
  const dday = new Date(timestamp);
  const now = new Date();
  dday.setHours(0,0,0,0);
  now.setHours(0,0,0,0);
  const timeDiff = dday.getTime() - now.getTime();
  return Math.floor(timeDiff/(1000*60*60*24));
}
